import React, { PureComponent } from 'react';

/**
 * Images
 */
import ImagePiramide from 'assets/images/piramede.png';
import ImageAmorc from 'assets/images/amorc-glp.png';

/**
 * Components.
 */
import Button from 'components/button';

/**
 * Style.
 */
import './second-section.scss';

import * as Scroll from 'react-scroll';

class SecondSection extends PureComponent {
  render() {
    const { reference, goToBeneffits } = this.props;

    return (
      <Scroll.Element name="second-section">
        <div className="second-section-wrapper" ref={reference}>
          <div className="mask" />
          <div className="second-section-division">
            <img src={ImagePiramide} alt="" />
            <img src={ImageAmorc} alt="" />
          </div>
          <div className="second-section-division">
            <div className="second-section-content-wrapper">
              <div className="second-section-content-header">
                Sobre a
                <br />
                Ordem Rosacruz
              </div>
              <hr />
              <div className="second-section-content">
                Tradicionalmente é considerada a mais antiga fraternidade do mundo,
                sendo o prolongamento da Fraternidade criada pelo Faraó Tutmés III
                em 1503 a. C. e que se destinava a estudar, experimentar e praticar
                os mais altos princípios da natureza.
              </div>
              <div className="second-section-button">
                <Button
                  orange
                  onClick={goToBeneffits}
                >
                  CONHEÇA OS BENEFÍCIOS
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Scroll.Element>
    );
  }
}

export default SecondSection;
